
import { Helmet } from 'react-helmet-async';
import Search from '../../pages/Search/Search';

export default function LandingPage() {
    return (
        <>
            <Helmet>
                <title> Landing Page </title>
            </Helmet>      
            <Search />   
        </>
    );
}
